<script setup>
import CFSidebarLink from '@/shared/components/CFSidebarLink.vue';

defineProps({
    title: {
        type: String,
        required: true,
    },
    items: {
        type: Array,
        required: true,
    },
});
</script>

<template>
    <div class="space-y-4">
        <p class="text-xs leading-3 font-bold">{{ title }}</p>

        <CFSidebarLink
            v-for="(item, index) in items"
            :key="index"
            :title="item.title"
            :href="item.href"
            :icon="item.icon"
            exact
        />
    </div>
</template>
